import * as React from "react";
import { Image, LinkOverlay, LinkBox } from "@chakra-ui/react";

import LOGO from "../../media/logos/palm_network_logo_bw.svg";

export const Logo = () => (
  <LinkBox>
    <LinkOverlay href="/">
      <Image src={LOGO} width="120px" alt="Palm Network App" padding="12px" />
    </LinkOverlay>
  </LinkBox>
);
